import { render, staticRenderFns } from "./OccupationTabs.vue?vue&type=template&id=3626bd32&scoped=true"
import script from "./OccupationTabs.vue?vue&type=script&lang=js"
export * from "./OccupationTabs.vue?vue&type=script&lang=js"
import style0 from "./OccupationTabs.vue?vue&type=style&index=0&id=3626bd32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3626bd32",
  null
  
)

export default component.exports